module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_1.fd02a62b.jpg";